



export function InitializeFilterDropdown(selectId: string, values: string[], tableFilter: IFilter, compoundValues: any[] = undefined, selected: boolean = true, shouldSort: boolean = true): void {
    $(selectId).selectpicker({
        dropupAuto: false,
        selectedTextFormat: "count",

        countSelectedText: (numSelected, numTotal) => {
            if (numSelected == numTotal) {
                return "All";
            }
            else {
                return numSelected + " Selected";
            }
        }
    });

    if (compoundValues == undefined) {
        values.forEach((element: any) => {
            $(selectId).append(new Option(element, element, false, selected));
        });
    }
    else {
        // Sort with "--" at the bottom
        if (shouldSort) {
            compoundValues.sort((x1: string[], x2: string[]) => {
                if (x1[1].startsWith("-") && !x2[1].startsWith("-")) {
                    return 1;
                }
                else if (x2[1].startsWith("-") && !x1[1].startsWith("-")) {
                    return -1;
                }
                else {
                    return x1[1].localeCompare(x2[1]);
                }
            });
        }
        
        compoundValues.forEach((element: any[]) => {
            $(selectId).append(new Option(element[1], element[0], false, selected));
        });
    }

    $(selectId).selectpicker("refresh");

    $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
        tableFilter.triggerFilter();
    });
}

export function InitializeFilterOptGroupDropdown(selectId: string, optGroups: DropdownOptGroup[], tableFilter: IFilter, selected: boolean = true, shouldSort: boolean = true): void {
    $(selectId).selectpicker({
        dropupAuto: false,
        selectedTextFormat: "count",

        countSelectedText: (numSelected, numTotal) => {
            if (numSelected == numTotal) {
                return "All";
            }
            else {
                return numSelected + " Selected";
            }
        }
    });

    if (shouldSort) {
        optGroups.sort((x1, x2) => x1.groupDisplayLabel.localeCompare(x2.groupDisplayLabel));
    }


    let dropdownHtml = "";
    optGroups.forEach(optGroup => {
        let optionHtml = "";
        let isSelected: string = "";
        if (selected) isSelected = "selected"
        if (optGroup.options != undefined) {
            if (shouldSort) {
                optGroup.options.sort((x1: string[], x2: string[]) => x1[1].localeCompare(x2[1]));
            }
            optGroup.options.forEach(option => {
                optionHtml += `<option value="${option[0]}" ${isSelected}>${option[1]}</option>`;
            });
        }
        let dataGroupId = "";
        if (optGroup.groupId) {
            dataGroupId = `data-group-id="${this.groupId}"`;
        }
        let content = `
            <optgroup label="${optGroup.groupDisplayLabel}" ${dataGroupId}>
                ${optionHtml}
            </optgroup>
        `;

        dropdownHtml += content;
    });
    $(selectId).empty().html(dropdownHtml);

    $(selectId).selectpicker("refresh");

    $(selectId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
        tableFilter.triggerFilter();
    });
}

export function GetSelectedDropdownValues(selectId: string): any {
    return $(selectId).val();
}

export interface IFilter {
    triggerFilter(): void;
}

export function ResetDropdownFilters(filterList: string[]): void {
    filterList.forEach((dropdownId: string) => {
        $(dropdownId).selectpicker('selectAll');
        $(dropdownId).selectpicker('refresh');
    });
}

export interface ICompoundFilterItem {
    id: string;
    value: string;
}

export class DropdownOptGroup {
    groupDisplayLabel: string;
    groupId: string;
    options: string[][]; // [["1", "DisplayValue1"], ["2", "DisplayValue2"]]

    constructor(optGroupLabel: string, options: string[][], groupId: string = "") {
        this.groupDisplayLabel = optGroupLabel;
        this.options = options;
        this.groupId = groupId;
    }
}